import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FavoriteCardTypeEnum, UserFavoriteCardData } from '../../../user-favorite-data.model';
import { Currency } from '../../../../../model/landingModel';
import { MediaPictureService } from 'projects/common/services/media-picture.service';
import { FavoriteSocialService } from '../../../favorite-social.service';

@Component({
  selector: 'cars-card',
  template: `
    <div>
      <!-- Header is on the top of the card -->
      <div class="heading-spacing">
      <card-header
        [showDeleteBtn]="showDeleteBtn"
        (onDeleteFavoriteClick)="onDeleteFavoriteClick.emit()"
        [externalId]="data.external_id"
        [product]="data.product"
        [flow]="flow"
      >
          <div>
            <div class="eva-3-h5">
              {{ data.main_text }}
            </div>

            <div class="eva-3-caption -eva-3-tc-gray-1 auxiliary-text" [innerHTML]="data.auxiliary_text"></div>
          </div>
        </card-header>
      </div>
      <div>
        <div class="eva-3-offer-card">
          <div class="image-and-icons-section">
            <div class="car-img-section">
              <img class="car-image" srcset="{{ favImage }}" alt="" loading="lazy" />
            </div>
            <div class="icons-section">
              <fav-characteristics-icons [characteristics]="data.characteristics!" />
            </div>
          </div>

          <span *ngIf="data.outstanding_driver && cardType !== FavoriteCardTypeEnum.REDUCED" class="favorite-card-driver eva-3-driver offer-card-main-driver">
            <span class="driver-text">
              <fav-image [src]="driverImage" [cssClass]="'driver-image'"></fav-image>
              {{ data.outstanding_driver.text }}
            </span>
          </span>

          <div class="favorite-card-content-spacing">
            <favorite-card-drivers [data]="data" [tooltipsPosition]="position === 0 ? 'right' : 'left' "></favorite-card-drivers>
          </div>

          <div class="overall-rating-section">
            <img [src]="logo" alt="" loading="lazy" />
            <div>
              <div class="overall-rating">
                <div *ngIf="data.overall_rating" class="eva-3-rating -good -sm">
                  <span class="rating-text">{{ data.overall_rating }}</span>
                </div>
                <div *ngIf="data.overall_rating_text">
                  <span class="overall-rating-text">{{ data.overall_rating_text }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="favorite-card-pricebox-section"
            *ngIf="cardType !== FavoriteCardTypeEnum.REDUCED">

            <favorite-card-pricebox
              [data]="data"
              [moduleId]="moduleId"
              [moduleIndex]="moduleIndex"
              [currency]="currency"
              [locale]="locale"
              [isWhiteLabel]="isWhiteLabel"
              [showAlertBtn]="showAlertBtn"
              [uniqueId]="uniqueId"
            ></favorite-card-pricebox>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['../common-styles.scss', './cars-card.component.scss'],
})
export class CarsCardComponent implements OnInit{
  @Input() data: UserFavoriteCardData;
  @Input() moduleId: string;
  @Input() uniqueId: string;
  @Input() moduleIndex: number;
  @Input() currency: Currency;
  @Input() locale: string;
  @Input() isWhiteLabel: boolean;
  @Input() showAlertBtn: boolean;
  @Input() flow: string;
  @Input() showDeleteBtn: boolean;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDeleteFavoriteClick = new EventEmitter();
  @Input() position: number;
  @Input() cardType: FavoriteCardTypeEnum;

  favImage: string | undefined;
  driverImage: string | undefined;
  logo: string | undefined;
  FavoriteCardTypeEnum = FavoriteCardTypeEnum;

  constructor(public mediaPictureService: MediaPictureService) {}

  ngOnInit(): void {
    this.favImage = this.mediaPictureService.getSrcset(this.data.picture_link, "0x72");

    if (this.data.outstanding_driver) {
      this.driverImage = this.mediaPictureService.getMediaUrl(this.data.outstanding_driver.icon_src);
    }

    if (this.data.logo) {
      this.logo = this.mediaPictureService.getMediaUrl(this.data.logo);
    }
  }
}
